import styled from "styled-components";

export const CentralPageContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
	width: 100%;

	.header {
		display: flex;
		justify-content: space-between;
		padding: 1rem;
		width: 100%;
		border-bottom: 1px solid #f5f5f5;
	}
	.header__user-info {
		align-items: center;
		color: #1233db;
		display: flex;
		font-size: 14px;
		font-weight: 500;
		padding: 0 1rem;
	}
	.header__user-image {
		align-items: center;
		background-color: #f3f4fa;
		border-radius: 50%;
		border: 1px solid #1233db;
		display: flex;
		height: 46px;
		justify-content: center;
		margin-right: 1rem;
		width: 46px;
	}

	button {
		border: none;
		background-color: transparent;
	}

	h3 {
		margin-top: 2rem;
		font-family: "Montserrat";
		font-size: 48px;
		font-style: normal;
		font-weight: 400;

		span {
			font-weight: bold;
		}
	}

	p {
		font-size: 28px;
		font-weight: 500;
		line-height: 42px;
	}

	.cards-grid {
		display: flex;
		width: 90%;
		flex-wrap: wrap;
		justify-content: center;
		padding: 1rem;
		gap: 1rem;
	}
	.grid__card {
		align-items: center;
		box-shadow: 0px 10px 25px -12px rgba(218, 218, 218, 0.25);
		display: flex;
		flex-direction: column;
		height: 223px;
		justify-content: space-between;
		width: 292px;
		cursor: pointer;
		color: #000;
		border-radius: 8px;
		&:hover {
			transition: 0.3s ease-in-out;
			background-color: #1233db;
			color: #fff;
		}
	}

	.grid__card-top {
		align-items: center;
		background-color: #f3f4fa;
		border-radius: 6px 6px 0px 0px;
		display: flex;
		height: 100%;
		justify-content: center;
		width: 100%;
	}

	.grid__card-bottom {
		align-items: center;
		display: flex;
		font-size: 20px;
		font-size: 20px;
		font-weight: 600;
		font-weight: 600;
		height: 60px;
		justify-content: center;
		width: 100%;
	}
`;
